exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-4ef80bcc]{background:#000;opacity:.7}.overlay-enter[data-v-4ef80bcc],.overlay-leave-to[data-v-4ef80bcc]{opacity:0}.overlay-enter-active[data-v-4ef80bcc],.overlay-leave-active[data-v-4ef80bcc]{transition:all .3s}", ""]);

// exports
